import { makeStyles } from "@/ui/kit/styles/makeStyles";

export default makeStyles()(() => ({
  closeBtn: {
    "&, &:hover": {
      backgroundColor: "transparent",
    },
    color: "inherit",
  },
}));
